// The free 30-day Premium trial offered right after signup is discontinued. Set this back to
// `true` to bring it back: the welcome screen, its "Continue" / "Start Free" buttons and the
// trial subscription call are all still in place behind it.
export const FREE_PREMIUM_TRIAL_ENABLED = false;
